import { Columns } from 'react-bulma-components';
const { Column } = Columns;

export { Column, Columns };
